module.exports = __webpack_public_path__ + "img/hover-iocn1.ec4ced45.svg";